import {Component, OnInit} from '@angular/core';

import {FormsModule} from '@angular/forms';
import {HubManagedUser} from '../../model/hub-session';
import {HubApiService} from '../../services/hub-api.service';

@Component({
  selector: 'hub-users',
  imports: [FormsModule],
  templateUrl: './users.component.html',
  styleUrl: './users.component.css'
})
export class UsersComponent implements OnInit {
  users: HubManagedUser[] = [];
  newEmail = '';
  newPassword = '';
  newAdmin = false;
  createModalOpen = false;
  passwords: Record<number, string> = {};
  loading = true;
  error = '';
  success = '';

  constructor(private hubApi: HubApiService) {
  }

  ngOnInit(): void {
    this.newPassword = this.generatePassword();
    this.reload();
  }

  createUser(): void {
    this.clearMessages();
    this.hubApi.createUser(this.newEmail, this.newPassword, this.newAdmin).subscribe({
      next: (response) => {
        this.users = response.users;
        this.newEmail = '';
        this.newPassword = this.generatePassword();
        this.newAdmin = false;
        this.createModalOpen = false;
        this.success = this.t('HubUserCreatedMessage');
      },
      error: (error) => this.error = error.error?.message || this.t('HubUserCreateFailedMessage')
    });
  }

  setRole(user: HubManagedUser, role: 'admin' | 'processAdmin' | 'translator', value: boolean): void {
    this.clearMessages();
    this.hubApi.setUserRole(user.id, role, value).subscribe({
      next: (response) => this.users = response.users,
      error: (error) => this.error = error.error?.message || this.t('HubUserRoleFailedMessage')
    });
  }

  setPassword(user: HubManagedUser): void {
    const password = this.passwords[user.id] || '';
    if (!password) return;
    this.clearMessages();
    this.hubApi.setUserPassword(user.id, password).subscribe({
      next: (response) => {
        this.users = response.users;
        this.passwords[user.id] = '';
        this.success = this.t('HubPasswordChangedMessage');
      },
      error: (error) => this.error = error.error?.message || this.t('HubPasswordChangeFailedMessage')
    });
  }

  deleteUser(user: HubManagedUser): void {
    if (!confirm(this.t('UserDeleteConfirmation'))) return;
    this.clearMessages();
    this.hubApi.deleteUser(user.id).subscribe({
      next: (response) => {
        this.users = response.users;
        this.success = this.t('HubUserDeletedMessage');
      },
      error: (error) => this.error = error.error?.message || this.t('HubUserDeleteFailedMessage')
    });
  }

  t(key: string): string {
    return this.hubApi.translate(key) || key;
  }

  private reload(): void {
    this.hubApi.listUsers().subscribe({
      next: (response) => {
        this.users = response.users;
        this.loading = false;
      },
      error: (error) => {
        this.error = error.error?.message || this.t('HubUsersLoadFailedMessage');
        this.loading = false;
      }
    });
  }

  private generatePassword(): string {
    return Math.random().toString(36).slice(2, 10) + Math.random().toString(36).slice(2, 8);
  }

  private clearMessages(): void {
    this.error = '';
    this.success = '';
  }
}
